import type { Schemas } from '#shopware'
import { mediaIncludes } from './media'

export const productManufacturerIncludes: Schemas['Includes'] = {
    product_manufacturer: [
        'id',
        'link',
        'name',
        'description',
        'media',
        'translated',
        'customFields.custom_a4g_warranty_label_years',
    ],
    ...mediaIncludes,
}
